function r(r,t){void 0===t&&(t=JSON.stringify);for(var n=[],a={},e=0;e<r.length;e++){var f=r[e],i=t(f);a[i]||(n.push(f),a[i]=!0)}return n}export{r as default};
